import { Reducer } from 'redux';
import { IMPERSONATE_USER } from 'types';
import { SessionActionTypes, SessionState } from './types';

const initialState: SessionState = {
  session: false,
  currentUser: {},
  isAuthenticated: false
};

const reducer: Reducer<SessionState> = (state = initialState, action: any) => {
  switch (action.type) {
    // SESSION_INIT
    case SessionActionTypes.SESSION_INIT: {
      return {
        ...initialState
      };
    }
    // SESSION_START
    case SessionActionTypes.SESSION_START: {
      return {
        ...state,
        session: true,
        sessionExpiryIn: action.payload || undefined
      };
    }
    // SET_USER_SESSION
    case SessionActionTypes.SET_USER_SESSION: {
      return {
        ...state,
        currentUser: action.payload,
        isAuthenticated: true,
        session: true
      };
    }
    // SET_AUTHENTICATED
    case SessionActionTypes.SET_AUTHENTICATED: {
      return {
        ...state,
        isAuthenticated: action.payload
      };
    }
    case SessionActionTypes.SET_SCREEN_SIZE: {
      return {
        ...state,
        screenSize: action.payload
      };
    }
    case SessionActionTypes.SET_IS_USER_REG:
      return {
        ...state,
        isRegistered: action.payload
      };
    // SESSION_END
    case SessionActionTypes.SESSION_END: {
      sessionStorage.removeItem(IMPERSONATE_USER.SESSION_NAME);
      return {
        session: false,
        isAuthenticated: false,
        currentUser: {},
        screenSize: state?.screenSize
      };
    }
    case SessionActionTypes.SET_SESSION_USER_ORGANISATION: {
      const { currentUser } = state;
      const Organisation = currentUser.Organisations.find(
        (o: any) => o.id === action.payload.orgId
      );
      return {
        ...state,
        currentUser: {
          ...currentUser,
          role: action.payload.role,
          Organisation,
          organisationId: action.payload.orgId
        }
      };
    }
    case SessionActionTypes.SET_REDIRECT_PATH: {
      return {
        ...state,
        redirectPath: action.payload
      };
    }
    case SessionActionTypes.SET_IS_FROM_SWXLOCATE: {
      return {
        ...state,
        isFromSwxLocate: action.payload
      };
    }
    case SessionActionTypes.SET_BASEMAP_SESSION: {
      return {
        ...state,
        basemapSession: action.payload
      };
    }
    case SessionActionTypes.SET_PURCHASED_AUTHORISATION: {
      return {
        ...state,
        purchasedAuthorisation: action.payload
      };
    }
    default:
      return state;
  }
};

export { reducer as SessionReducer };
